import _ from "lodash";
import { createSelector } from "reselect";
import { ACCOUNT_TYPES, FEATURES } from "../../app/appConstants";
import { getAppFeatures } from "../../app/appSelectors";
import parseAccountName from "../../utils/parseAccountName";
import { BONUS_NAMES } from "./bonusesConstants";

const moduleSelector = state => state.bonuses;

export const getBonusesActiveList = createSelector(
    moduleSelector, bonus => bonus.bonusesActiveList,
);

export const getBonusesAvailableList = createSelector(
    moduleSelector, bonus => bonus.bonusesAvailableList,
);

export const getPromocodesActive = createSelector(
    getBonusesActiveList, list => _.filter(list, { 'is_promocode': true }),
);

export const getBonusActiveGift50 = createSelector(
    getBonusesActiveList, bonusesActiveList =>
        _.find(bonusesActiveList, { name: BONUS_NAMES.GIFT50 }),
);

export const getBonusAvailableNewLifeLiveAccount = createSelector(
    getBonusesAvailableList, list => _.find(list, (item) =>
        item.bonus_name === BONUS_NAMES.NEW_LIFE && parseAccountName(item.account).type === ACCOUNT_TYPES.LIVE)
);

export const getBonusActiveNewLifeLiveAccount = createSelector(
    getBonusesActiveList, list => _.find(list, (item) =>
        item.name === BONUS_NAMES.NEW_LIFE && parseAccountName(item.account).type === ACCOUNT_TYPES.LIVE)
);

export const getIsRespawnAvailable = createSelector(
    [getAppFeatures, getBonusActiveNewLifeLiveAccount, getBonusAvailableNewLifeLiveAccount],
    (features, bonusActiveNewLifeLiveAccount, bonusAvailableNewLifeLiveAccount) =>
        !!features?.[FEATURES.NEW_LIFE] && (!!bonusActiveNewLifeLiveAccount || !!bonusAvailableNewLifeLiveAccount)
);

export const getNewLifeAccounts = createSelector(
    moduleSelector, state => state.newLifeAccounts,
);

export const getNewLifeAccountsError = createSelector(
    moduleSelector, state => state.newLifeAccountsError,
);

export const getNewLifeAccountsIsLoading = createSelector(
    moduleSelector, state => state.newLifeAccountsIsLoading,
);

export const getNewLifeRespawnError = createSelector(
    moduleSelector, state => state.newLifeRespawnError,
);

export const getNewLifeRespawnInProgress = createSelector(
    moduleSelector, state => state.newLifeRespawnInProgress,
);

export const getNewLifeRespawnSuccess = createSelector(
    moduleSelector, state => state.newLifeRespawnSuccess,
);

export const getWelcomeBonusActive = createSelector(
    getBonusesActiveList, state => _.find(state, { name: BONUS_NAMES.WELCOME })
);

export const getWelcomeBonusAvailable = createSelector(
    getBonusesAvailableList, state => _.find(state, { bonus_name: BONUS_NAMES.WELCOME })
);

export const getWelcomeApplyBonus = createSelector(
    moduleSelector, state => state.welcomeApplyBonus,
);

export const getWelcomeBannerOpened = createSelector(
    moduleSelector, state => state.welcomeBannerOpened,
);

export const getNewLifeRespawnBannerOpened = createSelector(
    moduleSelector, state => state.newLifeRespawnBannerOpened,
);
